<template>
  <div class="fd-xwzx">
    <el-row :gutter="21">
      <!-- <el-col :span="4">
        <leftMenu :menuList="menuList" :path='$router.currentRoute.path'></leftMenu>
      </el-col> -->
      <el-col :span="24">
        <div class="fd-content-bg">
          <el-table :data="tableData" :show-header="false" style="width: 100%;" @row-click="gotoDetails"
            row-class-name="rowClass">
            <el-table-column prop="title" min-width="380">
              <template slot-scope="scope">
                <div
                  style="float:left;width:7px;height:7px;line-height:7px;background:#D8D8D8;border-radius:50%;display:inline-block;margin-bottom:2px;margin-right:6px;margin-top:10px">
                </div>
                <span :title="scope.row.title" class="fd-rowTiltle">{{ scope.row.title }}</span>
                <!--首页新闻标题-->
              </template>
            </el-table-column>
            <el-table-column prop="publishDate"> </el-table-column>
          </el-table>
          <el-pagination background layout="prev,pager,next,sizes" :total="total" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" @size-change="handleSizeChange" :page-sizes="[15,30,45,60]"
            :page-size="pageSize" style="margin:20px auto;font-family:'STHeiti',serif">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import leftMenu from '../components/leftMenu.vue';
export default {
  components: {
    leftMenu,
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 15,
      columnCode: '',
      menuList: [],
      tableData: [],
      flag: 0,
      sign: 0,
    };
  },
  created() {
    this.columnCode = this.$route.query.columnCode;
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.getList(true);
  },
  mounted() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  },
  methods: {
    getList(confirm) {
      if (confirm) {
        this.currentPage = 1;
      }
      if (this.columnCode === 'SYZT_JGDJ_DJXW') {
        this.flag = 1;
      }
      if (this.columnCode === 'yjsxxgk') {
        this.sign = 1;
      }
      
      const rangeType = {
        columnCode: this.columnCode,
        flag: this.flag,
      };
      if (this.columnCode === 'SYZT_TSG_TSJS') {
        const url = `http://www.zysylib.org.cn:82/webscarch/default.aspx`;
        window.open(url);
      } else {
        this.axios.get(
          `/api/v1/portal/secondary/fgd/${this.currentPage}/${this.pageSize}`,
          {},
          rangeType,
          (resp) => {
            if (resp && resp.status === 200) {
              this.tableData = resp.data.list;
              this.total = resp.data.total;
            }
          },
          // (error) => {
          //   console.error(error);
          //   this.$message({
          //     type: "error",
          //     message: "查询失败",
          //   });
          // }
        );
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    /**
     * 跳转到新闻详情页面
     * @param ：row  当前列表行数据行
     * @author ： 吴俊迪 wujundi
     */
    gotoDetails(row) {
      console.log(row);
      this.$router.push({
        path: '/wwnry',
        query: {
          id: row.id,
          flag: row.flag,
          sign: this.sign,
          // menuList: this.$route.query.menuList,
          path: this.$router.currentRoute.path,
        },
      });
    },
  },
};
</script>
<style>
.rowClass {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/syxw.vue